import React from 'react';

export default class NoComponent extends React.Component{
	
	render(){
		return(
			<div className="text-center loadingAnim">
			&nbsp;
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/common/NoComponent.js